import React from 'react'
import DisplayOption from 'enums/DisplayOption'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { WidgetId } from 'features/types'
import useCrosstabData from './useCrosstabData'
import { CrosstabWidgetsType } from '../../types'
import HeatmapDisplay from '../HeatmapDisplay'
import BarDisplay from '../BarDisplay'

const CrosstabWidget = ({
  widgetId,
  isAudienceQuery = false,
  onHeatmapClick,
  onBarClick,
  enableHeatmapTooltip = true
}: {
  widgetId: WidgetId
  isAudienceQuery?: boolean
  onHeatmapClick: (target: any) => void
  onBarClick: (target: any) => void
  enableHeatmapTooltip?: boolean
}) => {
  const widgetSetting = useDashboardWidgetSetting<CrosstabWidgetsType>(widgetId)
  const crosstabData = useCrosstabData(widgetId, isAudienceQuery)

  switch (widgetSetting.displayOption) {
    case DisplayOption.TABLE:
      return (
        <HeatmapDisplay
          widgetId={widgetId}
          crosstabData={crosstabData}
          onClick={onHeatmapClick}
          enableTooltip={enableHeatmapTooltip}
        />
      )
    case DisplayOption.BAR:
      return (
        <BarDisplay
          type="bar"
          widgetId={widgetId}
          crosstabData={crosstabData}
          onClick={onBarClick}
        />
      )
    case DisplayOption.COLUMN:
      return (
        <BarDisplay
          type="column"
          widgetId={widgetId}
          crosstabData={crosstabData}
          onClick={onBarClick}
        />
      )
    default:
      throw new Error(`Unsupported display option: ${widgetSetting.displayOption}`)
  }
}

export default CrosstabWidget
